<div class="o-layout__item c-section__right u-layout-grow">
  <div class="c-form__item u-layout-auto u-width-100">
    <div class="o-layout__item c-card">
      <div class="c-table__responsive u-border-all u-border-radius u-border-0">
        <ls-table
          [loading]="loading$ | async"
          [cols]="4"
          class="c-table--hoverable"
        >
          <thead>
            <tr>
              <th>
                <span
                  i18n="Table|Header for shiftsSettings - Name @@tableHeaderShiftSettingsName"
                  >Shifts</span
                >
              </th>
              <th>
                <span
                  i18n="Table|Header for shiftsSettings - startTime @@tableHeaderStartTime"
                  >Start Time</span
                >
              </th>
              <th>
                <span
                  i18n="Table|Header for shiftsSettings - endTime @@tableHeaderEndTime"
                  >End Time</span
                >
              </th>
              <th class="u-align-right">
                <span
                  i18n="Table|Header for shiftsSettings - Actions @@tableHeaderActions"
                  >Actions</span
                >
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let shift of (shifts$ | async)"
              (click)="editShift($event, shift)"
            >
              <td>
                {{ shift.name }}
              </td>
              <td>{{ getTimeFormatted(shift.startTime) }}</td>
              <td>{{ getTimeFormatted(shift.endTime) }}</td>
              <td class="u-align-right">
                <ls-action-button
                  [title]="'Edit Shift'"
                  [icon]="actionButtonIcons.PENCIL"
                  (action)="editShift($event, shift)"
                >
                </ls-action-button>
                <ls-action-button
                  [title]="'Delete Shift'"
                  [icon]="actionButtonIcons.TRASH"
                  (action)="deleteShift($event, shift)"
                >
                </ls-action-button>
              </td>
            </tr>
            <tr *ngIf="(shifts$ | async)?.length <= 0">
              <td colspan="4">
                <div class="c-empty u-pattern-plus">
                  <div class="c-empty__container c-empty__container--small">
                    <img src="assets/img/visuals/visual-empty.png" alt="" />
                    <p
                      i18n="ShiftSettings| Info when no shifts are visible @@messageNoShifts"
                    >
                      No shifts are configured yet. Please add a shift by
                      clicking on the button below.
                    </p>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </ls-table>
      </div>
    </div>
  </div>

  <div class="o-layout__item">
    <button
      type="button"
      class="o-button o-button--default u-float-right"
      (click)="openNewShiftModal($event)"
    >
      <i class="fa fa-plus" aria-hidden="true"></i>
      <span i18n="Button|Button to add a new shift to the settings"
        >Add shift</span
      >
    </button>
  </div>
</div>
